import React from 'react';
import './analytics.css'

const Analytics = (props) => {
    return ( <>
    <div className='analyticsdiv2'>
       <div className='anadiv6'>
            <div className='anadiv3'>
                <div className='anaicondiv'>
                    <img src={props.anaicon} alt="icon" className='anaicon' />
                </div>
                <h6 className='precentt'>{props.anaprecent}</h6>
            </div>
            <div className='anadiv4'>
                <h6 className='amountt'>{props.amountt}</h6>
                <h6 className='totall'>{props.anatotall}</h6>
            </div>
       </div>

    </div>
    </> );
}
 
export default Analytics;